import { useState } from "react";
import { useTranslation } from "react-i18next";
import PartnerFooter from "../../components/PartnerFooter";
import ScreenHeader from "../../components/ScreenHeader";
import "./phoneValidation.scss";

// V2 phone-validation page (route "/phone-validation", gated inside
// screens/userPhoneValidation.jsx). The V1 screen keeps owning the SendSmsCode
// call and the navigation to /otp-validation — they arrive here as onSubmit,
// which resolves false when the server rejects the phone (the input is then
// cleared, matching the legacy screen). No back control: this is a forced auth
// gate reached by redirect from the handshake, so there is nowhere to go back to.
function PhoneValidation({ fullName, needLastName, displayError, onSubmit }) {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [lastName, setLastName] = useState("");

  const greeting = fullName ? `${t("HEY")} ${fullName},` : `${t("HEY")},`;
  const disabled = phone.length < 10 || (needLastName && lastName.trim().length === 0);

  const handleSubmit = async () => {
    const ok = await onSubmit(phone, lastName);
    if (!ok) setPhone("");
  };

  return (
    <div className="pv-v2">
      <ScreenHeader title={t("PHONE_VALIDATION.TITLE")} variant="none" />

      <div className="pv-v2-content">
        <h1 className="pv-v2-title">{greeting}</h1>
        <p className="pv-v2-subtitle">{t("PHONE_VALIDATION.TWO_FACTOR_AUTH")}</p>

        {needLastName && (
          <input
            type="text"
            name="lastName"
            autoComplete="family-name"
            className="pv-v2-input"
            placeholder={t("PHONE_VALIDATION.LAST_NAME_PLACEHOLDER")}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        )}

        <input
          type="tel"
          name="phone"
          inputMode="tel"
          autoComplete="tel"
          className="pv-v2-input pv-v2-input--phone"
          placeholder={t("PHONE_VALIDATION.PHONE_PLACEHOLDER")}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <button type="button" className="pv-v2-cta" onClick={handleSubmit} disabled={disabled}>
          {t("PHONE_VALIDATION.CONTINUE")}
        </button>

        {displayError && (
          <div className="pv-v2-error">
            <p>{t("PHONE_VALIDATION.PHONE_ERROR_HEADER")}</p>
            <p>
              {t("PHONE_VALIDATION.PHONE_ERROR_MESSAGE")} <a href="tel:033730300">03-3730300</a>
            </p>
          </div>
        )}
      </div>

      <PartnerFooter />
    </div>
  );
}

export default PhoneValidation;
